module.exports = __webpack_public_path__ + "static/media/banner.57e4683d.png";